// amplitudeTracker.ts
import * as amplitude from '@amplitude/analytics-browser';
export const initializeAmplitude = (apiKey, options) => {
    //  const sessionReplayTracking = sessionReplayPlugin({
    //     sampleRate: 1, // 100% sample rate, should reduce for production traffic.
    //   });
    //  amplitude.add(sessionReplayTracking);
    var _a;
    amplitude.init(apiKey, {
        defaultTracking: (_a = options === null || options === void 0 ? void 0 : options.defaultTracking) !== null && _a !== void 0 ? _a : true,
    });
};
export const identifyUser = (userId) => {
    amplitude.setUserId(userId);
};
export const clearUserIdentity = () => {
    amplitude.reset();
};
export const trackEvent = (eventName, eventProperties) => {
    amplitude.track(eventName, eventProperties);
};
